import { render } from "./TerminiCliente.vue?vue&type=template&id=0befd493&ts=true"
import script from "./TerminiCliente.vue?vue&type=script&lang=ts"
export * from "./TerminiCliente.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__